import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { Asset, ASSET_TYPE, AssetRevision } from 'assets-model';
import { AssetService, AssetTypeService, BusinessUnitService, CostCentreService, MechanicalAspectService, RefCodeStorage } from 'assets-service';
import { ASSET_SEARCH_RESULT_DATA_COLUMNS, AssetSearchComponent } from '../search/asset-search.component';
import { R } from '@angular/cdk/keycodes';

export const ASSET_DATA_UPLOAD_COLUMNS = ['selectedForImport', ...ASSET_SEARCH_RESULT_DATA_COLUMNS, 'tags']//, ...ASSET_SEARCH_ALL_ASPECT_COLUMNS];

export type ImportRow = {
  selectedForImport: boolean;
}

export type AssetImportRow = Asset & ImportRow;

@Component({
  selector: 'app-asset-data-upload',
  templateUrl: './asset-data-upload.component.html',
  styleUrls: ['./asset-data-upload.component.scss']
})
export class AssetDataUploadComponent extends AssetSearchComponent {

  importRows: AssetImportRow[];

  get rowsLoaded() {
    return this.importRows != null && this.importRows.length > 0;
  }

  @ViewChild("fileInput") fileInputRef: ElementRef;
  selectedFile: File = null;

  error: any;

  displayedColumns: string[] = [...ASSET_DATA_UPLOAD_COLUMNS];
  disabledColumns: string[] = [];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected assetService: AssetService,
    protected assetTypeService: AssetTypeService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected mechanicalAspectService: MechanicalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, assetService, assetTypeService, businessUnitService, costCentreService, mechanicalAspectService, refCodeStorage, fb, formStorage, injector);
    this.autoSearch = false;
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    if (this.sort) {
      this.sort.disabled = true;
    }
  }

  //disable actual search functionality
  createServiceArguments() {
    return {}
  }

  uploadFile() {
    if (this.selectedFile != null) {
      this.assetService.getAssetsFromFile(this.selectedFile).subscribe(
        data => {
          this.importRows = <any>data.items;
          this.importRows.forEach(row => row.selectedForImport = true);
          this.error = null;
        },
        error => {
          this.importRows = [];
          this.error = error.error;
          if (!this.error.friendlyMessage) {
            this.error = {
              friendlyMessage: "Unkown error, see dialog for details.",
              title: "Unknown"
            }
            throw error;
          }
        }
      )
    }
  }

  importEnabled() {
    return this.importRows != null && this.importRows.filter(r => r.selectedForImport).length > 0;
  }

  import() {
    var selectedAssets = this.importRows.filter(r => r.selectedForImport);
    this.assetService.importAll(selectedAssets).subscribe(
      data => {
        this.importRows = [];
        this.error = null;
        this.openSimpleConfirmationDialog("All assets imported successfully. Do you want to view these assets in the search screen?", "Import Successful", "Yes", "No").afterClosed().subscribe(
          result => {
            if (result) {
              this.router.navigate(ASSET_TYPE.searchRouteBase);
            }
          }
        );
      },
    );
  }

  clearFileInput() {
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = null;
    }
  }

  fileInputChanged(files: FileList) {
    this.selectedFile = files[0]
  }

  toggleSelected(row: AssetImportRow) {
    row.selectedForImport = !row.selectedForImport;
  }

  cellClass(element: AssetImportRow, fieldName: string): any {
    var cls = super.cellClass(element, fieldName) || {};
    cls['no-import'] = element.selectedForImport == false;
    return cls;
  }

  rowClass(row: AssetImportRow) {
    var cls = {
      'no-import': row.selectedForImport == false
    }
    return cls;
  }

  selectAll() {
    this.importRows.forEach(r => r.selectedForImport = true);
  }

  deselectAll() {
    this.importRows.forEach(r => r.selectedForImport = false);
  }


}
